import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const RequestsFilters = ({
  searchQuery,
  onSearchChange,
  selectedCaseType,
  onCaseTypeChange,
  selectedStatus,
  onStatusChange,
  dateRange,
  onDateRangeChange,
  onClearFilters,
}) => {
  const caseTypes = [
    { value: '', label: 'همه انواع پرونده' },
    { value: 'اظهارنامه قضایی', label: 'اظهارنامه قضایی' },
    { value: 'شکایت', label: 'شکایت' },
    { value: 'لایحه', label: 'لایحه' },
  ];

  const statusOptions = [
    { value: '', label: 'همه وضعیت‌ها' },
    { value: 'در حال بررسی', label: 'در حال بررسی' },
    { value: 'تکمیل شده', label: 'تکمیل شده' },
    { value: 'نیاز به بازنگری', label: 'نیاز به بازنگری' },
  ];

  const hasActiveFilters =
    searchQuery ||
    selectedCaseType ||
    selectedStatus ||
    dateRange?.from ||
    dateRange?.to;

  return (
    <div className="bg-card rounded-lg border border-border p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center space-x-2 space-x-reverse">
          <Icon name="Filter" size={20} />
          <span>فیلتر درخواست‌ها</span>
        </h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            className="text-muted-foreground hover:text-foreground">
            <Icon name="X" size={16} className="ml-1" />
            پاک کردن فیلترها
          </Button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search Input */}
        <div className="lg:col-span-2">
          <Input
            type="search"
            placeholder="جستجو در موضوع و توضیحات..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>

        {/* Case Type Filter */}
        <div>
          <select
            value={selectedCaseType}
            onChange={(e) => onCaseTypeChange(e?.target?.value)}
            className="w-full px-3 py-2 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            {caseTypes?.map((type) => (
              <option key={type?.value} value={type?.value}>
                {type?.label}
              </option>
            ))}
          </select>
        </div>

        {/* Status Filter */}
        <div>
          <select
            value={selectedStatus}
            onChange={(e) => onStatusChange(e?.target?.value)}
            className="w-full px-3 py-2 border border-border rounded-md bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent">
            {statusOptions?.map((status) => (
              <option key={status?.value} value={status?.value}>
                {status?.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      {/* Date Range Filters */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div>
          <Input
            type="date"
            label="از تاریخ"
            value={dateRange?.from}
            onChange={(e) =>
              onDateRangeChange({ ...dateRange, from: e?.target?.value })
            }
          />
        </div>
        <div>
          <Input
            type="date"
            label="تا تاریخ"
            value={dateRange?.to}
            onChange={(e) =>
              onDateRangeChange({ ...dateRange, to: e?.target?.value })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default RequestsFilters;
